const initScrollAnimatedVideo = () => {
    const animationVideoWidgetList = document.querySelectorAll("[data-animation-video-widget]");
    if (animationVideoWidgetList && animationVideoWidgetList.length > 0) {
        animationVideoWidgetList.forEach((animationVideoWidget) => {
            const setHeightDesktop = animationVideoWidget.querySelector("[data-height-desktop]");
            const setHeightMobile = animationVideoWidget.querySelector("[data-height-mobile]");
            const vidContainerMobile = animationVideoWidget.querySelector("[data-video-container-mobile]");
            const vidDesktop = animationVideoWidget.querySelector("[data-video-desktop]");
            const vidMobile = animationVideoWidget.querySelector("[data-video-mobile]");
            const isScrolling = false; // Flag to track scrolling
            if (vidMobile && vidDesktop) {
                if (window.innerWidth <= 767) {
                    scrollVideo(vidMobile, setHeightMobile, isScrolling);
                }
                else {
                    scrollVideo(vidDesktop, setHeightDesktop, isScrolling);
                }
            }
        });
    }
};
const scrollVideo = (vid, setHeight, isScrolling) => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    let frameNumber = 0;
    const playbackConst = parseInt(vid.getAttribute("data-video"));
    vid.addEventListener("loadedmetadata", () => {
        setHeight.style.height = Math.floor(vid.duration) * playbackConst + "px";
    });
    const scrollPlay = () => {
        const vidTop = setHeight.getBoundingClientRect().top;
        const vidHeight = setHeight.getBoundingClientRect().height;
        const windowHeight = window.innerHeight;
        if (vidTop < windowHeight && vidTop + vidHeight > 0) {
            // Video is at least partially in the viewport.
            // frameNumber should be get a refactoring. The * -1 + 1 is a workarounds.
            frameNumber = ((vidTop / vidHeight) * Math.floor(vid.duration)) * -1 + 1;
            vid.currentTime = frameNumber;
            vid.pause();
        }
    };
    const handleScroll = () => {
        if (!isScrolling) {
            isScrolling = true;
            window.requestAnimationFrame(() => {
                scrollPlay();
                isScrolling = false;
            });
        }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
};
// Helper function to check if an element is in the viewport
const isElementInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
};
